// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TablaComparacionUtilidadDelArticuloPorCliente__SorteableHeaderTitle__\\+apD7:hover {\r\n  color: rgba(0, 0, 0, 0.54);\r\n  cursor: pointer;\r\n}\r\n\r\n.TablaComparacionUtilidadDelArticuloPorCliente__TablasComparacionComprobantesContainer__MbG65 {\r\n  display: flex;\r\n  flex-direction: row;\r\n}\r\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SorteableHeaderTitle": "TablaComparacionUtilidadDelArticuloPorCliente__SorteableHeaderTitle__+apD7",
	"TablasComparacionComprobantesContainer": "TablaComparacionUtilidadDelArticuloPorCliente__TablasComparacionComprobantesContainer__MbG65"
};
export default ___CSS_LOADER_EXPORT___;
